<template>
  <div class="icon-gadget">
    <div class="gadget-contents">
      <ul class="navi">
        <li class="customer" v-show="hasCrmLicense">
          <a href="#" @click="moveTo('customer')">顧客</a>
        </li>
        <li class="list" v-show="hasCrmLicense"><a href="#" @click="moveTo('member_list')">顧客リスト</a></li>
        <li class="promotion" v-show="hasCrmLicense"><a href="#" @click="moveTo('promotion')">プロモーション</a></li>
        <li class="tag" v-show="hasCrmLicense"><a href="#" @click="moveTo('tag')">タグ</a></li>
        <li class="purpose" v-show="hasCrmLicense"><a href="#" @click="moveTo('purpose')">来店用途</a></li>
        <li class="daily" v-show="hasSalesReportLicense"><a href="#" @click="moveTo('daily')">日報</a></li>
        <li class="sales_item" v-show="hasSalesReportLicense"><a href="#" @click="moveTo('sales_item')">商品別売上</a></li>
        <li class="sales_payment" v-show="hasSalesReportLicense"><a href="#" @click="moveTo('sales_payment')">支払別売上</a></li>
        <li class="sales_category" v-show="hasSalesReportLicense"><a href="#" @click="moveTo('sales_category')">カテゴリー別売上</a></li>
        <li class="payment_note" v-show="hasSalesReportLicense"><a href="#" @click="moveTo('payment_note')">支払管理表</a></li>
        <li class="sales_time" v-show="hasSalesReportLicense"><a href="#" @click="moveTo('sales_time')">時間売上</a></li>
        <li class="sales_weekday" v-show="hasSalesReportLicense"><a href="#" @click="moveTo('sales_weekday')">曜日売上</a></li>
        <li class="analize" v-show="hasSalesReportLicense"><a href="#" @click="moveTo('analyze')">売上分析</a></li>
        <li class="sales_staff" v-show="hasSalesReportLicense"><a href="#" @click="moveTo('sales_staff')">担当者別売上</a></li>
        <li class="cash_note" v-show="hasSalesReportLicense"><a href="#" @click="moveTo('cash_note')">現金管理表</a></li>
        <li class="audit" v-show="hasSalesReportLicense"><a href="#" @click="moveTo('audit')">監査レポート</a></li>
        <li class="shop_sales_analyze" v-show="hasSalesReportLicense && isGroupMode"><a href="#" @click="moveTo('shop_sales_analyze')">店舗別売上分析</a></li>
        <li class="shop_payment_note" v-show="hasSalesReportLicense && isGroupMode"><a href="#" @click="moveTo('shop_payment_note')">店舗別支払管理</a></li>
        <li class="sales_month" v-show="hasSalesReportLicense && isGroupMode"><a href="#" @click="moveTo('sales_month')">月別売上分析</a></li>
        <li class="shop_menu_sales" v-show="hasSalesReportLicense && isGroupMode"><a href="#" @click="moveTo('shop_menu_sales')">店舗別メニュー売上</a></li>
        <li class="time_setting" v-show="hasSalesReportLicense && !isGroupMode"><a href="#" @click="moveTo('time_setting')">時間帯</a></li>
        <li class="budget" v-show="hasSalesReportLicense"><a href="#" @click="moveTo('budget')">予算入力</a></li>
        <li class="department" v-show="hasSalesReportLicense && !isGroupMode"><a href="#" @click="moveTo('department')">部門</a></li>
        <li class="category" v-show="hasSalesReportLicense && !isGroupMode"><a href="#" @click="moveTo('category')">グループカテゴリー</a></li>
        <li class="setting"><a href="#" @click="moveTo('settings')">設定</a></li>
      </ul>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import SERVER_TYPE from '@/consts/serverTypes'

export default {
  name: 'IconLinkGadget',
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters('account', [
      'hasGroup',
      'isGroupMode',
      'hasCrmLicense',
      'hasSalesReportLicense',
      'hasReserveLicense',
    ]),
  },
  methods: {
    moveTo (to) {
      switch (to) {
        case 'customer':
        case 'member_list':
        case 'promotion':
        case 'tag':
        case 'purpose':
        case 'shop':
          this.$request.auth.redirectToken().then(res => {
            const token = res.body.token
            let tmp = res.body.servers.find(x => x.serverType === SERVER_TYPE.CRM)
            const crm = tmp ? `${tmp.endpoint}account/login/${token}/` : null
            let link = crm + to
            window.location.href = link
          })
          break
        case 'daily':
          this.$router.push({name: 'ReportDaily'})
          break
        case 'sales_item':
          this.$router.push({name: 'ReportSalesItem'})
          break
        case 'sales_payment':
          this.$router.push({name: 'ReportSalesPayment'})
          break
        case 'sales_category':
          this.$router.push({name: 'ReportSalesCategory'})
          break
        case 'payment_note':
          this.$router.push({name: 'ReportPaymentAnalyze'})
          break
        case 'sales_time':
          this.$router.push({name: 'ReportPaymentTime'})
          break
        case 'sales_weekday':
          this.$router.push({name: 'ReportSalesWeekday'})
          break
        case 'analyze':
          this.$router.push({name: 'ReportSalesAnalyze'})
          break
        case 'shop_sales_analyze':
          this.$router.push({name: 'ReportShopSalesAnalyze'})
          break
        case 'sales_staff':
          this.$router.push({name: 'ReportSalesStaff'})
          break
        case 'cash_note':
          this.$router.push({name: 'ReportCashNote'})
          break
        case 'audit':
          this.$router.push({name: 'ReportAudit'})
          break
        case 'shop_payment_note':
          this.$router.push({name: 'ReportShopPaymentNote'})
          break
        case 'sales_month':
          this.$router.push({name: 'ReportSalesMonth'})
          break
        case 'shop_menu_sales':
          this.$router.push({name: 'ReportShopMenuSales'})
          break
        case 'time_setting':
          this.$router.push({name: 'TimeSetting'})
          break
        case 'budget':
          this.$router.push({name: 'ReportSalesBudget'})
          break
        case 'category':
          this.$router.push({name: 'Category'})
          break
        case 'department':
          this.$router.push({name: 'Department'})
          break
        case 'settings':
          this.$router.push({name: 'Settings'})
          break
      }
      console.log(to)
    },
  },
}
</script>

<style scoped>
.icon-gadget {
  width: 100%;
  height: auto;
  min-height: 100px;
  box-sizing: border-box;
  transition-property: width;
  transition-duration: .1s;
}

.gadget-contents {
  background-color: #FFF;
  box-sizing: border-box;
  box-shadow: 1px 1px 1px rgba(0,0,0,0.1);
}

ul.navi {
  display: block;
  width: 100%;
  height: auto;
  overflow: hidden;
  list-style: none;
  padding: 0;
  margin-bottom: 0px;
  /* text-align: center; */
}

ul.navi li {
  display: inline-block;
  width: 110px;
  height: 110px;
  padding: 15px 10px;
}

ul.navi li a {
  display: block;
  width: 110px;
  height: 25px;
  padding-top: 85px;
  text-align: center;
  background-color: #FFF;
  background-repeat: no-repeat;
  background-position: center 17px;
  background-size: 57px auto;
  border-radius: 8px;
  box-shadow: 0 2px 3px rgba(0,0,0,0.3);
  font-size: 10px;
  font-weight: bold;
  color: #999;
  text-decoration: none;
}

ul.navi li a:active {
  background-color: #FAFAFA;
  box-shadow: none;
  box-shadow: 0 0 1px rgba(0,0,0,0.1);
  color: #9C0;
}
ul.navi li.customer a {
  background-image: url('/static/img/top_icon/customer.png');
}
ul.navi li.customer a:active {
  background-image: url('/static/img/top_icon/customer_on.png');
}
ul.navi li.list a {
  background-image: url('/static/img/top_icon/list.png');
}
ul.navi li.list a:active {
  background-image: url('/static/img/top_icon/list_on.png');
}
ul.navi li.promotion a {
  background-image: url('/static/img/top_icon/promotion.png');
}
ul li.promotion a:active {
  background-image: url('/static/img/top_icon/promotion_on.png');
}
ul.navi li.daily a {
  background-image: url('/static/img/top_icon/calendar.png');
}
ul.navi li.daily a:active {
  background-image: url('/static/img/top_icon/calendar_on.png');
}
ul.navi li.sales_item a {
  background-image: url('/static/img/top_icon/sales_shohin.png');
}
ul.navi li.sales_item a:active {
  background-image: url('/static/img/top_icon/sales_shohin_on.png');
}
ul.navi li.sales_payment a {
  background-image: url('/static/img/top_icon/sales_shiharai.png');
}
ul.navi li.sales_payment a:active {
  background-image: url('/static/img/top_icon/sales_shiharai_on.png');
}
ul.navi li.sales_category a {
  background-image: url('/static/img/top_icon/sales_category.png');
}
ul.navi li.sales_category a:active {
  background-image: url('/static/img/top_icon/sales_category_on.png');
}
ul.navi li.tag a {
  background-image: url('/static/img/top_icon/tag.png');
}
ul.navi li.tag a:active {
  background-image: url('/static/img/top_icon/tag_on.png');
}
ul.navi li.category a {
  background-image: url('/static/img/top_icon/category.png');
}
ul.navi li.category a:active {
  background-image: url('/static/img/top_icon/category_on.png');
}
ul.navi li.department a {
  background-image: url('/static/img/top_icon/category.png');
}
ul.navi li.department a:active {
  background-image: url('/static/img/top_icon/category_on.png');
}
ul.navi li.setting a {
  background-image: url('/static/img/top_icon/setting.png');
}
ul.navi li.setting a:active {
  background-image: url('/static/img/top_icon/setting_on.png');
}
ul.navi li.reservation a {
  background-image: url('/static/img/top_icon/reservation.png');
}
ul.navi li.reservation a:active {
  background-image: url('/static/img/top_icon/reservation_on.png');
}
ul.navi li.purpose a {
  background-image: url('/static/img/top_icon/purpose.png');
}
ul.navi li.purpose a:active {
  background-image: url('/static/img/top_icon/purpose_on.png');
}
ul.navi li.payment_note a {
  background-image: url('/static/img/top_icon/payment_note.png');
}
ul.navi li.payment_note.current a,
ul.navi li.payment_note a:active {
  background-image: url('/static/img/top_icon/payment_note_on.png');
}
ul.navi li.sales_time a {
  background-image: url('/static/img/top_icon/sales_time.png');
}
ul.navi li.sales_time.current a,
ul.navi li.sales_time a:active {
  background-image: url('/static/img/top_icon/sales_time_on.png');
}
ul.navi li.sales_weekday a {
  background-image: url('/static/img/top_icon/sales_weekday.png');
}
ul.navi li.sales_weekday.current a,
ul.navi li.sales_weekday a:active {
  background-image: url('/static/img/top_icon/sales_weekday_on.png');
}
ul.navi li.analize a {
  background-image: url('/static/img/top_icon/analize.png');
}
ul.navi li.analize.current a,
ul.navi li.analize a:active {
  background-image: url('/static/img/top_icon/analize_on.png');
}
ul.navi li.shop_sales_analyze a {
  background-image: url('/static/img/top_icon/shop_sales_analyze.png');
}
ul.navi li.shop_sales_analyze.current a,
ul.navi li.shop_sales_analyze a:active {
  background-image: url('/static/img/top_icon/shop_sales_analize_on.png');
}
ul.navi li.sales_staff a {
  background-image: url('/static/img/top_icon/sales_staff.png');
}
ul.navi li.sales_staff.current a,
ul.navi li.sales_staff a:active {
  background-image: url('/static/img/top_icon/sales_staff_on.png');
}
ul.navi li.cash_note a {
  background-image: url('/static/img/top_icon/cash_note.png');
}
ul.navi li.cash_note.current a,
ul.navi li.cash_note a:active {
  background-image: url('/static/img/top_icon/cash_note_on.png');
}
ul.navi li.audit a {
  background-image: url('/static/img/top_icon/audit.png');
}
ul.navi li.audit.current a,
ul.navi li.audit a:active {
  background-image: url('/static/img/top_icon/audit_on.png');
}
ul.navi li.shop_payment_note a {
  background-image: url('/static/img/top_icon/shop_payment_note.png');
}
ul.navi li.shop_payment_note.current a,
ul.navi li.shop_payment_note a:active {
  background-image: url('/static/img/top_icon/shop_payment_note_on.png');
}
ul.navi li.sales_month a {
  background-image: url('/static/img/top_icon/sales_month.png');
}
ul.navi li.sales_month.current a,
ul.navi li.sales_month a:active {
  background-image: url('/static/img/top_icon/sales_month_on.png');
}
ul.navi li.shop_menu_sales a {
  background-image: url('/static/img/top_icon/shop_menu_sales.png');
}
ul.navi li.shop_menu_sales.current a,
ul.navi li.shop_menu_sales a:active {
  background-image: url('/static/img/top_icon/shop_menu_sales_on.png');
}
ul.navi li.time_setting a {
  background-image: url('/static/img/top_icon/time_setting.png');
}
ul.navi li.time_setting.current a,
ul.navi li.time_setting a:active {
  background-image: url('/static/img/top_icon/time_setting_on.png');
}
ul.navi li.budget a {
  background-image: url('/static/img/top_icon/budget.png');
}
ul.navi li.budget.current a,
ul.navi li.budget a:active {
  background-image: url('/static/img/top_icon/budget_on.png');
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/IconLink.vue